import React, { SVGProps } from 'react';

export default function TaxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        d="M325.884,158.048l-0.434-0.071c-5.452-0.881-10.583,2.836-11.458,8.29c-0.873,5.452,2.838,10.582,8.291,11.457l0.35,0.057
			c0.551,0.091,1.098,0.135,1.638,0.135c4.807,0,9.047-3.477,9.854-8.375C335.023,164.092,331.333,158.946,325.884,158.048z"
      />
      <path
        d="M501.806,284.62c-11.645-11.644-30.59-11.644-42.234,0c-3.905,3.905-3.905,10.237,0,14.143
			c3.905,3.905,10.237,3.905,14.143,0c3.846-3.847,10.104-3.846,13.95,0c5.783,5.782,5.783,15.19,0,20.973
			c-3.973,3.974-9.256,6.162-14.876,6.162c-5.619,0-10.902-2.188-14.875-6.162c-0.006-0.006-0.013-0.012-0.02-0.018
			c0.069-1.922,0.115-3.847,0.115-5.78c0-61.915-36.453-118.435-92.868-143.991c-5.031-2.278-10.957-0.048-13.235,4.982
			c-2.279,5.031-0.048,10.957,4.982,13.235c49.279,22.323,81.121,71.692,81.121,125.773c0,47.153-23.706,90.564-63.413,116.124
			c-2.859,1.841-4.587,5.008-4.587,8.409V486c0,3.309-2.691,6-6,6h-48c-3.309,0-6-2.691-6-6v-19.698
			c0-7.921-6.444-14.365-14.364-14.365H192.373c-7.921,0-14.365,6.444-14.365,14.365V486c0,3.309-2.691,6-6,6h-48
			c-3.309,0-6-2.691-6-6v-47.53c0-3.4-1.728-6.568-4.587-8.408c-28.613-18.419-49.354-46.546-58.401-79.199
			c-1.335-4.82-6.026-7.915-10.984-7.239c-0.504,0.068-0.995,0.174-1.471,0.313h-9.588c-7.151,0-12.969-5.818-12.969-12.969v-34.063
			c0-7.151,5.818-12.969,12.969-12.969h9.715c0.436,0.122,0.884,0.214,1.343,0.277c4.958,0.679,9.648-2.417,10.984-7.237
			c15.55-56.08,64.983-96.542,123.009-100.685c5.509-0.393,9.656-5.178,9.263-10.687c-0.393-5.509-5.184-9.646-10.687-9.263
			c-9.539,0.681-18.869,2.236-27.917,4.562c-5.785-26.961-29.792-47.238-58.455-47.238h-3.803c-5.523,0-10,4.477-10,10v78.45
			C59.313,219.174,46,240.198,38.094,263.938h-5.117c-18.179,0-32.969,14.79-32.969,32.969v34.063
			c0,18.179,14.79,32.969,32.969,32.969h5.127c10.775,32.355,31.747,60.342,59.904,79.875V486c0,14.336,11.664,26,26,26h48
			c14.336,0,26-11.664,26-26v-14.063h92V486c0,14.336,11.664,26,26,26h48c14.336,0,26-11.664,26-26v-42.187
			c34.866-24.169,58.135-60.721,65.492-101.717c5.347,2.486,11.215,3.801,17.288,3.801c10.962,0,21.267-4.269,29.019-12.02
			C515.387,320.297,515.387,298.201,501.806,284.62z M96.429,134.148c16.957,2.664,30.385,16.078,33.088,33.021
			c-11.761,4.697-22.864,10.769-33.088,18.049V134.148z"
      />
      <path
        d="M120.298,249.06c-1.86-1.87-4.44-2.93-7.07-2.93c-2.64,0-5.21,1.06-7.07,2.93c-1.86,1.86-2.93,4.43-2.93,7.07
			c0,2.63,1.07,5.21,2.93,7.07c1.86,1.86,4.44,2.93,7.07,2.93c2.63,0,5.21-1.07,7.07-2.93c1.86-1.87,2.93-4.44,2.93-7.07
			S122.158,250.92,120.298,249.06z"
      />
      <path d="M304.288,213h-113.56c-5.523,0-10,4.477-10,10s4.477,10,10,10h113.56c5.523,0,10-4.477,10-10S309.811,213,304.288,213z" />
      <path
        d="M247.508,86.593c-29.224,0-53,23.776-53,53s23.776,53,53,53s53-23.776,53-53S276.732,86.593,247.508,86.593z
			 M247.508,172.593c-18.196,0-33-14.804-33-33c0-18.196,14.804-33,33-33s33,14.804,33,33
			C280.508,157.789,265.704,172.593,247.508,172.593z"
      />
      <path
        d="M247.491,0c-5.523,0-10,4.477-10,10v43.139c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10V10
			C257.491,4.477,253.014,0,247.491,0z"
      />
      <path
        d="M337.694,38.679c-3.905-3.905-10.237-3.905-14.143,0l-26.335,26.335c-3.905,3.905-3.905,10.237,0,14.143
			c1.953,1.953,4.513,2.929,7.072,2.929c2.559,0,5.119-0.976,7.071-2.929l26.335-26.335
			C341.599,48.917,341.599,42.585,337.694,38.679z"
      />
      <path
        d="M197.799,64.963l-26.335-26.335c-3.905-3.905-10.237-3.905-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l26.336,26.335
			c1.953,1.953,4.512,2.929,7.071,2.929c2.559,0,5.119-0.976,7.071-2.929C201.704,75.201,201.704,68.869,197.799,64.963z"
      />
      <path
        d="M173.781,307.726h-34.796c-5.523,0-10,4.477-10,10s4.477,10,10,10h7.398v53.955c0,5.523,4.477,10,10,10s10-4.477,10-10
			v-53.955h7.398c5.523,0,10-4.477,10-10S179.304,307.726,173.781,307.726z"
      />
      <path
        d="M267.981,377.84l-26.45-63.475c-1.552-3.727-5.193-6.154-9.23-6.154c-4.037,0-7.678,2.427-9.23,6.154l-26.45,63.475
			c-2.124,5.098,0.287,10.953,5.385,13.077c5.097,2.126,10.953-0.286,13.077-5.384l1.53-3.672h31.376l1.53,3.672
			c1.601,3.841,5.318,6.157,9.235,6.156c1.282,0,2.585-0.248,3.842-0.772C267.694,388.793,270.105,382.938,267.981,377.84z
			 M224.947,361.86l7.354-17.65l7.354,17.65H224.947z"
      />
      <path
        d="M335.119,349.717l17.264-26.548c3.011-4.63,1.698-10.824-2.932-13.835c-4.631-3.012-10.825-1.698-13.835,2.932
			l-12.426,19.108l-12.426-19.108c-3.011-4.63-9.205-5.943-13.835-2.932s-5.942,9.205-2.932,13.835l17.264,26.548l-17.264,26.548
			c-3.011,4.63-1.698,10.824,2.932,13.835c1.684,1.095,3.574,1.618,5.442,1.618c3.271,0,6.477-1.603,8.393-4.549l12.426-19.108
			l12.426,19.108c1.917,2.947,5.122,4.549,8.393,4.549c1.869,0,3.759-0.523,5.442-1.618c4.63-3.011,5.942-9.205,2.932-13.835
			L335.119,349.717z"
      />
    </svg>
  );
}
